/**
 * Knitting Program Upload Configuration
 */

export const KNITTING_PROGRAM_UPLOAD_CONFIG = {
  /**
   * Maximum number of chunk upload requests that run concurrently.
   * Each chunk is a single HTTP multipart request containing up to
   * MAX_FILES_PER_CHUNK files.
   */
  MAX_CONCURRENT_UPLOADS: 3,

  /**
   * Maximum number of files bundled into one upload HTTP request.
   * CC4 bundles (3 parts) are always kept together and count as one unit.
   */
  MAX_FILES_PER_CHUNK: 8,

  /**
   * Maximum number of file hashes sent in a single check-versions request.
   * Splitting large file sets into smaller batches avoids huge request
   * payloads and keeps the backend response time predictable.
   */
  CHECK_VERSIONS_BATCH_SIZE: 200,

  /**
   * Upload flow for N files:
   * 1. All files are hashed in a Web Worker (off the main thread).
   * 2. Hashes are sent to check-versions in batches of CHECK_VERSIONS_BATCH_SIZE.
   * 3. Files are split into chunks of MAX_FILES_PER_CHUNK.
   * 4. Up to MAX_CONCURRENT_UPLOADS chunks are uploaded in parallel.
   */
};
